(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["youngstars-contact"] && !Shopify.designMode) return;
  try {
    
  const initYoungstarsContact = (root = document) => {
    root.querySelectorAll('[data-youngstars-contact]').forEach((section) => {
      if (section.dataset.youngstarsContactReady === 'true') return;

      const country = section.querySelector('[data-country-selector]');
      const stateWrap = section.querySelector('[data-state-field]');
      const state = section.querySelector('[data-state-selector]');

      if (!country || !stateWrap || !state) return;

      section.dataset.youngstarsContactReady = 'true';

      const placeholderOption = country.options[0];
      if (placeholderOption) {
        placeholderOption.textContent = 'Please select';
        placeholderOption.value = '';
      }

      const updateState = () => {
        const selected = country.options[country.selectedIndex];
        const shouldShow = country.value === 'United States';
        let provinces = [];

        if (selected && selected.dataset && selected.dataset.provinces) {
          try {
            provinces = JSON.parse(selected.dataset.provinces);
          } catch (error) {
            provinces = [];
          }
        }

        state.innerHTML = '<option value="">State</option>';

        provinces.forEach((province) => {
          const option = document.createElement('option');
          option.value = province[0];
          option.textContent = province[1];
          state.appendChild(option);
        });

        stateWrap.hidden = !shouldShow;
        state.disabled = !shouldShow;
        state.required = shouldShow;
      };

      country.addEventListener('change', updateState);
      updateState();
    });
  };

  initYoungstarsContact();

  document.addEventListener('shopify:section:load', (event) => {
    initYoungstarsContact(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
